export const POST_STORE = 'POST_STORE'
export const LIST_STORE = 'LIST_STORE'
export const LIST_STORE_BRANCH = 'LIST_STORE_BRANCH'
export const GET_STORE = 'GET_STORE'
export const CHECK_UPLOAD_DOCUMENTS = 'CHECK_UPLOAD_DOCUMENTS'
